import React, { useState,useEffect } from "react";
import EmployeeNavbar from "./EmployeeNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";
function AllProductsEmployee() {
    const ID = Cookies.get("log_id");
    const [products,setProducts] = useState([]);
    function Fetch_All_Products() {
        axios.get(`${url.path}/all_products/`)
        .then((res) =>{
            if(res.data.status){
                const prd = res.data.products.map((pd) => ({
                    ...pd,
                    fileUrl: `${url.path}${pd.Image}`,
                }));
                setProducts(prd);
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    useEffect(() =>{
        Fetch_All_Products();
    }, [])
    const itemsPerPage = 3;
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);

    const filteredData = products.filter((item) =>
      item.Name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const offset = currentPage * itemsPerPage;
    const currentItems = filteredData.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageClick = ({ selected }) => {
      setCurrentPage(selected);
    };
    function searchTable(){
      var rows = document.querySelectorAll('#productstable tbody tr');
      var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
      rows.forEach(function(row) {
        var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
        row.style.display = text.includes(val) ? '' : 'none';
      });
    }
    return(
        <>
        <EmployeeNavbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>All Products</h3>
            </center>
            <div className="search-container">
                <input
                type="text"
                placeholder="Search..."
                onKeyUp={searchTable}
                className="search-input"
                id="search"
                />
            </div>
        <div className="table-container">
            
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Product Name</th>
            <th>Description</th>
            <th>Price</th>
            <th>Image</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {products.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Name}</td>
              <td>{i.Description}</td>
              <td>{i.Price}</td>
              <td> <img src={i.fileUrl} alt="Pic" style={{ width: "100px", height: "100px" }} /></td>
              <td><button style={{width:'60px',backgroundColor:'green',borderRadius:'5px',color:'white'}}>Buy</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default AllProductsEmployee;